// ABOUTME: Evidence API calls for source tracing
// ABOUTME: Fetches evidence with interview context and full transcript

import { apiClient } from './client'

export interface TranscriptQA {
  question_number: number | null
  question_text: string
  answer_text: string
}

export interface EvidenceSource {
  evidence_id: string
  quote: string
  reasoning: string
  evidence_type: string
  strength: string
  hypothesis_id: string
  hypothesis_statement: string
  interview_id: string
  interview_date: string | null
  research_area: string | null
  facilitator: string | null
  notetaker: string | null
  question: string
  answer: string
  question_number: number | null
  full_transcript: TranscriptQA[]
  learner_institution: string | null
  learner_group: string | null
  persona_confidence: string | null
}

export const evidenceApi = {
  /**
   * Fetch evidence source with interview context
   */
  async getEvidenceSource(evidenceId: string): Promise<EvidenceSource> {
    const response = await apiClient.get<EvidenceSource>(`/api/evidence/${evidenceId}`)
    return response.data
  }
}
